import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import VideoHero from './components/VideoHero';
import ExploreBrands from './components/ExploreBrands';
import Footer from './components/Footer';
import TestDrive from "./components/TestDrive";
import Collection from "./components/Collections.jsx";
import AboutUs from './components/About.jsx';
import ContactUs from './components/Contact.jsx';
import LoginSignup from './components/LoginSignup';
import AccountPage from './components/AccountPage';
import JoinPremium from './components/JoinPremium';
import Customize from "./components/Customize";
import BookingFlow from './components/BookingFlow';


import './App.css';

function App() {
  const [user, setUser] = useState(null); // ✅ Track the logged-in user

  return (
    <Router>
      {/* Pass user to Navbar */}
      <Navbar user={user} />
      <main>
        <Routes>
          <Route path="/" element={<><VideoHero /><ExploreBrands /></>} />
          <Route path="/test-drive" element={<TestDrive />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/customize" element={<Customize />} />
          <Route path="/booking-flow" element={<BookingFlow />} />

          
          {/* Pass setUser to LoginSignup for login/signup actions */}
          <Route path="/login" element={<LoginSignup setUser={setUser} />} />

          {/* Pass user to AccountPage */}
          <Route path="/account" element={<AccountPage user={user} />} />

          <Route path="/join-premium" element={<JoinPremium />} />

        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
